<template>
    <AdminLoginTemplate />
</template>

<script setup>
import AdminLoginTemplate from '@/components/templates/AdminLoginTemplate.vue';

</script>